import classNames from "classnames";
import { graphql } from "gatsby";
import React, { Fragment, useContext } from "react";
import Image from "./elements/image";
import PlayDark from "../icons/play-dark.svg";
import YoutubeContext from "../context/youtube";
import { Link } from "./link";
import safeSlugify from "../utility/safe-slugify";

const Highlight = ({ data }) => {
  const { showVideoModal } = useContext(YoutubeContext);
  return (
    <>
      {data.anchorDesktop && (
        <span id={safeSlugify(data.anchorDesktop)} className="tabs__scroll-anchor" />
      )}
      <div className="highlights">
        <div className="highlight" style={{ backgroundColor: data?.backColor || "#100e1b" }}>
          <div className="highlight__content">
            <div className="highlight__title">{data.mainTitle}</div>
            {data.abstract && (
              <div
                className="highlight__description"
                dangerouslySetInnerHTML={{
                  __html: data.abstract,
                }}
              ></div>
            )}
            {data.highlightCta && data.highlightCta.length > 0 && (
              <div className="highlight__cta">
                {data.highlightCta
                  ?.filter((cta) => cta.link && (cta.label || cta.type?.[0] !== "button"))
                  ?.map((cta, j) => (
                    <Fragment key={j}>
                      {cta.type?.[0] === "button" ? (
                        <Link
                          to={cta.link}
                          target={cta.target?.[0]}
                          className={classNames(
                            "btn-link  button secondary",
                            cta.color?.[0] === "white" && "btn-link--white  button tertiary"
                          )}
                          rel="noreferrer"
                        >
                          {cta.label}
                        </Link>
                      ) : (
                        <button
                          className="btn-play ml-4"
                          aria-label="Play"
                          name={cta.link}
                          onClick={showVideoModal}
                        >
                          <PlayDark />
                        </button>
                      )}
                      &nbsp;
                    </Fragment>
                  ))}
              </div>
            )}
          </div>
          <div className="highlight__image">
            <Image
              className={classNames(
                "highlight__image--mobile",
                data?.imageOpacity?.[0] === "low" && "opacity-low",
                data?.imageOpacity?.[0] === "medium" && "opacity-medium",
                data?.imageOpacity?.[0] === "high" && "opacity-high"
              )}
              image={data?.imageMobile?.image ? data?.imageMobile.image : data.imageDesktop.image}
              objectPosition={
                data?.imageMobile?.image
                  ? `${data.imageMobile?.image.field41892789?.[0] || "center"} ${
                      data.imageMobile?.image.field90383678?.[0] || "center"
                    }`
                  : `${data.imageDesktop.image.focuslr?.[0] || "center"} ${
                      data.imageDesktop.image.focustb?.[0] || "center"
                    }`
              }
              alt={
                data?.imageMobile?.image
                  ? data?.imageMobile?.image.value?.description || ""
                  : data.imageDesktop?.image?.value?.description || ""
              }
            />
            <Image
              className={classNames(
                "highlight__image--desktop",
                data?.imageOpacity?.[0] === "low" && "opacity-low",
                data?.imageOpacity?.[0] === "medium" && "opacity-medium",
                data?.imageOpacity?.[0] === "high" && "opacity-high"
              )}
              image={data.imageDesktop.image}
              objectPosition={`${data.imageDesktop.image.focuslr?.[0] || "center"} ${
                data.imageDesktop.image.focustb?.[0] || "center"
              }`}
              alt={data.image?.value?.description || ""}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Highlight;
export const fragment = graphql`
  fragment HighLightFragment on LiferayHighlight {
    abstract
    anchorDesktop
    anchorMobile
    imageMobile {
      image: field00972992 {
        value {
          description
        }
        node {
          publicURL
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      field41892789
      field90383678
    }
    imageDesktop {
      image {
        value {
          description
        }
        node {
          publicURL
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      focuslr
      focustb
    }
    highlightCta: cta {
      label
      color
      link
      target
      type
    }
    imageOpacity
    backColor
    mainTitle: title
  }
`;
